module.exports = __webpack_public_path__ + "static/media/webauthn-5.0c3ba05f.svg";